class HeaderNavigation extends HTMLElement {
  constructor() {
    super();
    this.onScrollEvents();
    this.btnEventButtons();
  }

  onScrollEvents() {
    window.addEventListener("scroll", () => {
      this.stickyNavigation();
    });
  }

  btnEventButtons() {
    const { megaMenuBtn, headerSearchIcons } =
      this.headerNavigationComponents();
    megaMenuBtn.forEach((btn) => {
      btn.addEventListener("mouseenter", this.hoverEnters.bind(this));
    });

    this.addEventListener("mouseleave", () => {
      this.closeAllMenus();
    });

    headerSearchIcons.forEach((searchIcon) => {
      searchIcon.addEventListener("click", () => {
        const event = new Event("open-navigation");
        document.dispatchEvent(event);
      });
    });
  }

  hoverEnters(e) {
    const menu = e.target.closest(".nav-flyout-menu");
    const targetHandle = e.currentTarget.dataset.handle;

    this.closeAllMenus();
    this.openMenu(menu, targetHandle);
  }

  showMenuContent() {}

  openMenu(menu, handle) {
    let menuContent = menu.querySelector(".nav-flyout-menu__content");
    //let menuBtn = menu.querySelector(".nav-flyout-menu__btn");

    // Update: handles show/hide of menu inner content
    for (let i = 0; i < menuContent.children.length; i++) {
      const child = menuContent.children[i];
      const childHandle = child.dataset.handle;
      if (childHandle === handle) {
        child.classList.replace("hidden", "flex");
      } else {
        child.classList.replace("flex", "hidden");
      }
    }

    menuContent.classList.remove("hidden");
    setTimeout(() => {
      menuContent.classList.remove("opacity-0");
      menuContent.classList.add("opacity-1");
      menuContent.classList.replace("-translate-y-6", "translate-y-0");
    }, 20);
  }

  closeAllMenus() {
    const { dropdownMenus } = this.headerNavigationComponents();
    dropdownMenus.forEach((menu) => {
      if (this.menuIsOpen(menu)) this.closeMenu(menu);
    });
  }

  menuIsOpen(menu) {
    return !menu
      .querySelector(".nav-flyout-menu__content")
      .classList.contains("hidden");
  }

  closeMenu(menu) {
    let menuContent = menu.querySelector(".nav-flyout-menu__content");

    menuContent.classList.add("opacity-0");
    menuContent.classList.add("ease-in");
    menuContent.classList.add("duration-300");

    menuContent.classList.remove("opacity-1");
    menuContent.classList.remove("ease-out");
    menuContent.classList.remove("duration-300");
    menuContent.classList.replace("translate-y-0", "-translate-y-6");

    setTimeout(() => {
      menuContent.classList.remove("ease-in");
      menuContent.classList.add("hidden");
      menuContent.classList.add("ease-out");
      menuContent.classList.add("duration-300");
      menuContent.classList.replace("-translate-y-6", "translate-y-0");
    }, 150);
  }

  stickyNavigation() {
    const { headerNavigation } = this.headerNavigationComponents();
    headerNavigation.parentElement.parentElement.classList.add(
      "sticky",
      "top-0",
      "z-30",
      "duration-300",
      "transition-all"
    );
  }

  headerNavigationComponents() {
    const headerNavigation = this.querySelector("#header-navigation");
    const megaMenuBtn = this.querySelectorAll(".nav-flyout-menu__btn");
    const dropdownMenus = this.querySelectorAll(".nav-flyout-menu");
    const headerSearchIcons = this.querySelectorAll(".nav-search-button");

    return { headerNavigation, megaMenuBtn, dropdownMenus, headerSearchIcons };
  }
}

class HeaderMobileNavigation extends HTMLElement {
  constructor() {
    super();
    this.btnEventListeners();
    this.resizeEventListeners();
  }

  btnEventListeners() {
    const { navToggleBtn, navigationDropdown } = this.mobileNavComponents();

    navToggleBtn.addEventListener("click", () => {
      this.toggleMobileNav();
    });

    navigationDropdown.forEach((navButton) => {
      navButton.addEventListener("click", () => {
        this.toggleDropdownNav(navButton);
      });
    });
  }

  resizeEventListeners() {
    window.addEventListener("resize", () => {
      if (this.tabletResolution()) {
        this.hideAllMobileDropdowns();
        this.toggleMobileNav(false);
      }
    });
  }

  hideAllMobileDropdowns() {
    const { mobileDropdownElements } = this.mobileNavComponents();
    mobileDropdownElements.forEach((dropdown) => {
      dropdown.classList.remove("opacity-100", "scale-y-100");
      dropdown.classList.add("opacity-0", "scale-y-0");
      dropdown.style.maxHeight = "0";
      dropdown.classList.replace("flex", "hidden");
    });
  }

  tabletResolution() {
    return window.innerWidth <= 1023;
  }

  toggleMobileNav(state = true) {
    const {
      mobileNavContent,
      mobileNavHamburgerIcon,
      mobileNavCloseIcon,
      predictiveSearch,
    } = this.mobileNavComponents();
    //Navigation closed

    if (mobileNavContent.classList.contains("hidden") && state) {
      if (
        predictiveSearch != null &&
        !predictiveSearch.classList.contains("hidden")
      ) {
        document.dispatchEvent(new Event("open-navigation"));
      }

      mobileNavHamburgerIcon.classList.add("hidden");
      mobileNavCloseIcon.classList.remove("hidden");

      mobileNavContent.classList.replace("hidden", "flex");
      mobileNavContent.style.maxHeight = mobileNavContent.scrollHeight + "px";

      mobileNavContent.offsetHeight;
      mobileNavContent.classList.remove("max-h-0");

      mobileNavContent.classList.add("opacity-100", "scale-y-100");
      mobileNavContent.classList.remove("opacity-0", "scale-y-0");
      document.body.classList.add("overflow-hidden");

      setTimeout(() => {
        mobileNavContent.style.maxHeight = "none";
      }, 300); // Match the transition duration
    } else {
      mobileNavContent.classList.remove("opacity-100", "scale-y-100");
      mobileNavContent.classList.add("opacity-0", "scale-y-0");
      mobileNavHamburgerIcon.classList.remove("hidden");
      mobileNavCloseIcon.classList.add("hidden");
      mobileNavContent.style.maxHeight = mobileNavContent.scrollHeight + "px";

      setTimeout(() => {
        mobileNavContent.style.maxHeight = "0";
        mobileNavContent.classList.replace("flex", "hidden");
      }, 300); // Match the transition duration
      document.body.classList.remove("overflow-hidden");
    }
  }

  toggleDropdownNav(button) {
    let targetElement = this.querySelector(
      `#mobile-nav-dropdown-${button.dataset.target}`
    );

    if (targetElement != null) {
      if (targetElement.classList.contains("hidden")) {
        targetElement.classList.replace("hidden", "flex");

        // targetElement.style.maxHeight = targetElement.scrollHeight + "px";

        targetElement.style.maxHeight = "100vh";

        targetElement.offsetHeight;
        targetElement.classList.remove("max-h-0");
        targetElement.style.overflow = "scroll";

        targetElement.classList.add("opacity-100", "scale-y-100");
        targetElement.classList.remove("opacity-0", "scale-y-0");

        targetElement.style.paddingBottom = "60vh";

        // targetElement.style.paddingBottom =
        //   targetElement.scrollHeight / 2 + "px";
      } else {
        targetElement.classList.remove("opacity-100", "scale-y-100");
        targetElement.classList.add("opacity-0", "scale-y-0");
        targetElement.style.maxHeight = "0";
        targetElement.style.paddingBottom = "0";
        setTimeout(() => {
          targetElement.classList.replace("flex", "hidden");
        }, 300); // Match the transition duration
      }
    } else {
      console.error("Navigation target not found!");
    }
  }

  mobileNavComponents() {
    const navToggleBtn = this.querySelector("#mobile-nav-toggle");
    const mobileNavContent = this.querySelector("#mobile-nav-content");
    const mobileNavHamburgerIcon = this.querySelector("#mobile-nav-hamburger");
    const mobileNavCloseIcon = this.querySelector("#mobile-nav-close");
    const navigationDropdown = this.querySelectorAll(
      ".mobile-nav-open-dropdown"
    );
    const mobileDropdownElements = this.querySelectorAll(
      ".mobile-dropdown-element"
    );

    const predictiveSearch = document.querySelector("#nav-search-bar");

    return {
      navToggleBtn,
      mobileNavContent,
      mobileNavHamburgerIcon,
      mobileNavCloseIcon,
      navigationDropdown,
      mobileDropdownElements,
      predictiveSearch,
    };
  }
}

class HeaderPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("open-navigation", this.toggleNavigationMenu);
  }

  toggleNavigationMenu() {
    const navigationSearchSection = document.querySelector("#nav-search-bar");
    if (navigationSearchSection.classList.contains("hidden")) {
      navigationSearchSection.classList.remove("hidden");
      navigationSearchSection.classList.add("animate-search-in");

      if (
        !document
          .getElementById("mobile-nav-content")
          .classList.contains("hidden")
      ) {
        document.getElementById("mobile-nav-content").classList.add("hidden");
        document
          .getElementById("mobile-nav-hamburger")
          .classList.remove("hidden");
        document.getElementById("mobile-nav-close").classList.add("hidden");
      }
    } else {
      navigationSearchSection.classList.replace(
        "animate-search-in",
        "animate-search-out"
      );

      setTimeout(() => {
        navigationSearchSection.classList.add("hidden");
        navigationSearchSection.classList.replace(
          "animate-search-out",
          "animate-search-in"
        );
      }, 300);
    }
  }
}

customElements.define("mobile-navigation", HeaderMobileNavigation);
customElements.define("header-navigation", HeaderNavigation);
customElements.define("header-predictive", HeaderPredictiveSearch);
